/* PITAKA India — PDP gallery + configuration diagrams + device dropdown.
   Works alongside Ella's variants.js: thumbs expose data-media-id="SECTION-MEDIA"
   so VariantRadios.updateMedia() can click them on variant change. */
(function () {
  'use strict';

  function initGallery(root) {
    if (root.dataset.pitakaReady) return;
    root.dataset.pitakaReady = '1';

    var track = root.querySelector('[data-pitaka-track]');
    if (!track) return;
    var slides = Array.prototype.slice.call(track.querySelectorAll('[data-pitaka-slide]'));
    var thumbs = Array.prototype.slice.call(root.querySelectorAll('[data-pitaka-thumb]'));
    var counter = root.querySelector('[data-pitaka-current]');
    var progress = root.querySelector('[data-pitaka-progress]');
    var prev = root.querySelector('[data-pitaka-prev]');
    var next = root.querySelector('[data-pitaka-next]');
    var current = 0;

    function render(index) {
      current = index;
      if (counter) counter.textContent = String(index + 1);
      if (progress && slides.length) progress.style.width = ((index + 1) / slides.length * 100) + '%';
      thumbs.forEach(function (t, i) {
        var active = i === index;
        t.classList.toggle('is-active', active);
        if (active) {
          t.setAttribute('aria-current', 'true');
          var strip = t.parentElement;
          if (strip && strip.scrollWidth > strip.clientWidth) {
            strip.scrollTo({ left: t.offsetLeft - strip.clientWidth / 2 + t.clientWidth / 2, behavior: 'smooth' });
          }
        } else {
          t.removeAttribute('aria-current');
        }
      });
      slides.forEach(function (s, i) {
        var v = s.querySelector('video');
        if (v && i !== index && !v.paused) v.pause();
      });
      syncDeviceColorState(root, index);
    }

    function goTo(index, smooth) {
      if (!slides.length) return;
      index = (index + slides.length) % slides.length;
      track.scrollTo({ left: slides[index].offsetLeft, behavior: smooth === false ? 'auto' : 'smooth' });
      render(index);
    }

    var ticking = false;
    track.addEventListener('scroll', function () {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(function () {
        ticking = false;
        var w = track.clientWidth || 1;
        var idx = Math.round(track.scrollLeft / w);
        if (idx !== current && idx >= 0 && idx < slides.length) render(idx);
      });
    }, { passive: true });

    if (prev) prev.addEventListener('click', function () { goTo(current - 1); });
    if (next) next.addEventListener('click', function () { goTo(current + 1); });
    thumbs.forEach(function (t) {
      t.addEventListener('click', function () { goTo(parseInt(t.dataset.index, 10) || 0); });
    });
    track.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowLeft') { e.preventDefault(); goTo(current - 1); }
      if (e.key === 'ArrowRight') { e.preventDefault(); goTo(current + 1); }
    });

    // Desktop mouse drag (global site uses grab-to-swipe)
    var dragX = null, dragLeft = 0, moved = false;
    track.addEventListener('pointerdown', function (e) {
      if (e.pointerType !== 'mouse') return;
      dragX = e.clientX; dragLeft = track.scrollLeft; moved = false;
      track.style.scrollSnapType = 'none'; track.style.scrollBehavior = 'auto';
    });
    window.addEventListener('pointermove', function (e) {
      if (dragX === null) return;
      var dx = e.clientX - dragX;
      if (Math.abs(dx) > 4) moved = true;
      track.scrollLeft = dragLeft - dx;
    });
    window.addEventListener('pointerup', function (e) {
      if (dragX === null) return;
      var dx = e.clientX - dragX;
      dragX = null;
      track.style.scrollSnapType = ''; track.style.scrollBehavior = '';
      if (Math.abs(dx) > 40) goTo(current + (dx < 0 ? 1 : -1)); else goTo(current);
    });
    track.addEventListener('click', function (e) { if (moved) { e.preventDefault(); e.stopPropagation(); moved = false; } }, true);

    root.pitakaGoTo = goTo;
    initDeviceColors(root);

    var start = parseInt(root.dataset.startIndex, 10) || 0;
    if (start > 0) goTo(start, false); else render(0);
    window.addEventListener('resize', function () { goTo(current, false); });
  }

  /* ---------- Phone colour picker (device-color-list) ---------- */
  function currentDevice(fallback) {
    var radio = document.querySelector('.pitaka-pdp input.product-form__radio[name="Device"]:checked');
    return radio ? radio.value : (fallback || '');
  }

  function renderDeviceColors(root) {
    var box = root.querySelector('[data-pitaka-device-colors]');
    if (!box) return;
    var list = box.querySelector('[data-pitaka-device-color-items]');
    var data = box._pitakaData || [];
    var device = currentDevice(box.dataset.device);
    var seen = {};
    var items = data.filter(function (e) {
      var ok = !device || !e.device || e.device === device;
      if (!ok || seen[e.color]) return false;
      seen[e.color] = true;
      return true;
    });
    if (!items.length) items = data.filter(function (e) { if (seen[e.color]) return false; seen[e.color] = true; return true; });
    list.innerHTML = '';
    items.forEach(function (e) {
      var li = document.createElement('li');
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'device-color-list__option';
      b.setAttribute('aria-pressed', 'false');
      b.dataset.index = e.index;
      b.innerHTML = '<span class="device-color-list__dot" style="background-color:' + e.hex + '"></span><span class="device-color-list__name"></span>';
      b.querySelector('.device-color-list__name').textContent = e.color;
      b.addEventListener('click', function () {
        if (root.pitakaGoTo) root.pitakaGoTo(e.index);
      });
      li.appendChild(b);
      list.appendChild(li);
    });
    box.hidden = items.length === 0;
  }

  function syncDeviceColorState(root, index) {
    root.querySelectorAll('.device-color-list__option').forEach(function (b) {
      b.setAttribute('aria-pressed', String(parseInt(b.dataset.index, 10) === index));
    });
  }

  function initDeviceColors(root) {
    var box = root.querySelector('[data-pitaka-device-colors]');
    if (!box) return;
    try { box._pitakaData = JSON.parse(box.querySelector('[data-pitaka-device-color-data]').textContent); } catch (err) { box._pitakaData = []; }
    renderDeviceColors(root);
    document.addEventListener('change', function (e) {
      if (e.target && e.target.matches && e.target.matches('input.product-form__radio[name="Device"]')) {
        window.setTimeout(function () { renderDeviceColors(root); }, 0);
      }
    });
  }

  function syncConfiguration(picker) {
    picker.querySelectorAll('fieldset[data-option-handle]').forEach(function (fs) {
      var checked = fs.querySelector('input.product-form__radio:checked');
      if (!checked) return;
      var value = checked.value;
      var diagrams = fs.querySelectorAll('[data-configuration-diagrams] [data-configuration]');
      if (diagrams.length) {
        var matched = false;
        diagrams.forEach(function (svg) {
          var on = svg.getAttribute('data-configuration') === value;
          if (on) matched = true;
          svg.classList.toggle('is-hidden', !on);
        });
        var wrap = fs.querySelector('[data-configuration-diagrams]');
        if (wrap) wrap.hidden = !matched;
      }
      var name = fs.querySelector('[data-pitaka-selected-value]');
      if (name) name.textContent = value;
      var select = fs.querySelector('[data-pitaka-device-select]');
      if (select && select.value !== value) select.value = value;
    });
  }

  function initPicker(picker) {
    if (picker.dataset.pitakaReady) return;
    picker.dataset.pitakaReady = '1';
    picker.addEventListener('change', function (e) {
      if (e.target && e.target.matches('[data-pitaka-device-select]')) return;
      syncConfiguration(picker);
    });
    picker.querySelectorAll('[data-pitaka-device-select]').forEach(function (select) {
      select.addEventListener('change', function (e) {
        e.stopPropagation();
        var fs = select.closest('fieldset');
        var radios = fs ? fs.querySelectorAll('input.product-form__radio') : [];
        for (var i = 0; i < radios.length; i++) {
          if (radios[i].value === select.value) {
            radios[i].checked = true;
            radios[i].dispatchEvent(new Event('change', { bubbles: true }));
            break;
          }
        }
      });
    });
    syncConfiguration(picker);
  }

  function init(scope) {
    (scope || document).querySelectorAll('.pitaka-pdp [data-pitaka-gallery]').forEach(initGallery);
    (scope || document).querySelectorAll('[data-pitaka-variant-radios]').forEach(initPicker);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); });
  else init();
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
